import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import R from 'ramda';
import Heading from '@cotyorg/ccx-atoms/Heading';
import Paragraph from '@cotyorg/ccx-atoms/Paragraph';
import { Newsletter } from '@cotyorg/ccx-molecules/Newsletter';
import { Social } from '@cotyorg/ccx-molecules/Social';
import Picture from '@cotyorg/ccx-atoms/Picture';

const generateNewsletterClassNames = () => classNames(
  'social-newsletter social-newsletter-full-width',
  'text--center',
);

const generateContentWrapperClassNames = () => classNames(
  'social-newsletter__content-wrapper',
  'flex-container align-center',
  'grid-x',
);

const generateContentBoxClassNames = () => classNames(
  'social-newsletter__content-box',
  'xsmall-14 small-12 medium-9 xlarge-7',
  'flex-container flex-dir-column',
);

const SocialNewsletterFullWidth = ({
  socialNewsletterData,
  headingLevel,
  headingUnderlined,
  buttonIconSrc,
  socialIconSrc,
  buttonType = 'default',
  rel,
}) => (
  <div className={generateNewsletterClassNames()}>
    <Picture
      alt={R.prop('alt')(socialNewsletterData)}
      src={R.prop('imageSrc')(socialNewsletterData)}
      srcset={R.prop('imageSrcSet')(socialNewsletterData)}
    />

    <div className="grid-container">
      <div className={generateContentWrapperClassNames()}>
        <div className={generateContentBoxClassNames()}>
          <Heading
            extraClass="social-newsletter__heading"
            level={headingLevel}
            isUnderlined={headingUnderlined}
          >
            {R.path(['newsletter', 'heading'], socialNewsletterData)}
          </Heading>

          <Paragraph extraClass="newsletter__description">
            {R.path(['newsletter', 'description'], socialNewsletterData)}
          </Paragraph>

          <Newsletter
            buttonType={buttonType}
            buttonIconSrc={buttonIconSrc}
          />

          {R.path(['newsletter', 'agreementText'], socialNewsletterData) && (
            <Paragraph extraClass="newsletter__agreement-text text--center">
              {R.path(['newsletter', 'agreementText'], socialNewsletterData)}
            </Paragraph>
          )}

          <Social
            socialIconSrc={socialIconSrc}
            rel={rel}
          />
        </div>
      </div>
    </div>
  </div>
);

SocialNewsletterFullWidth.propTypes = {
  socialNewsletterData: PropTypes.shape({
    imageSrc: PropTypes.string,
    alt: PropTypes.string,
    imageSrcSet: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
      src: PropTypes.string.isRequired,
    })),
    newsletter: PropTypes.shape({
      heading: PropTypes.string,
      description: PropTypes.string,
      agreementText: PropTypes.string,
    }),
  }),
  headingLevel: PropTypes.number,
  headingUnderlined: PropTypes.bool,
  buttonType: PropTypes.oneOf(['default', 'icon']),
  buttonIconSrc: PropTypes.string,
  socialIconSrc: PropTypes.objectOf(PropTypes.string),
  rel: PropTypes.string,
};

export default SocialNewsletterFullWidth;
